<template>
    <div id="sig-container">

        <div class="full form-horizontal">
            <div class="loader" v-if="loading"><i class="fa fa-spinner fa-2x fa-spin text-info"></i></div>
            <contacto />
            <div class="row">
                <div class="col-md-6 form-group text-left"><a  href="javascript:void(0)" @click="abrirModalReferencia('registrar')" class="btn btn-sm btn-primary"><i class="fa fa-plus"></i>&nbsp;&nbsp;Crear nueva referencia</a></div>
                <div class="col-md-6 form-group text-right"><button @click="$router.go(-1)" class="btn btn-sm btn-primary">Volver</button></div>
            </div>
            <table-component :data="referencias" @click-event="clickEvent">
                <table-column slot="label" :label="'Nombre'" v-bind:value="'nombre'"></table-column>
                <table-column slot="label" :label="'Telefono'" v-bind:value="'telefono'"></table-column>
                <table-column slot="label" :label="'Direccion'" v-bind:value="'direccion'"></table-column>
                <table-column slot="label" :label="'Email'" v-bind:value="'email'"></table-column>
                <!--table-column slot="label" :label="'Observaciones'" v-bind:value="'observacion'"></table-column-->
                <table-column slot="label" :label="'Acciones'" :icon="'fa'">
                <template slot="icon" :icon="'fa fa-edit'" :class="'btn btn-sm btn-info'" :slug="'editar'" :tooltip="'Editar referencia'"></template>
                    <template slot="icon" :icon="'fa fa-trash'" :class="'btn btn-sm btn-info'" :slug="'eliminar'" :tooltip="'Elimianr referencia'"></template>
                </table-column>
            </table-component>
        </div>

        <modal class="modal fade" v-model="modalReferencia.open" ref="modal-referencia" :title="modalReferencia.titulo" id="modal-referencia" @hide="cerrarModal()">
            <form class="form-horizontal">

                <div class="form-group" :class="[errorReferencia.nombre ? 'has-warning' : '']">
                    <label class="col-md-3 control-label" for="text-input">Nombre*</label>
                    <div class="col-md-9">
                        <input type="text" id="nombre" v-model.trim="referencia.nombre" class="form-control" placeholder="Nombre de la referencia">
                        <span v-if="errorReferencia.nombre" :class="['text-warning']">{{errorReferencia.nombre[0]}}</span>
                    </div>
                </div>

                <div class="form-group" :class="[errorReferencia.telefono ? 'has-warning' : '']">
                    <label class="col-md-3 control-label" for="text-input">Telefono*</label>
                    <div class="col-md-9">
                        <input type="text" id="telefono" v-model.trim="referencia.telefono" class="form-control" placeholder="Telefono de la referencia">
                        <span v-if="errorReferencia.telefono" :class="['text-warning']">{{errorReferencia.telefono[0]}}</span>
                    </div>
                </div>

                <div class="form-group" :class="[errorReferencia.telefono_extra ? 'has-warning' : '']">
                    <label class="col-md-3 control-label" for="text-input">Telefono fijo</label>
                    <div class="col-md-9">
                        <input type="text" id="telefono_extra" v-model.trim="referencia.telefono_extra" class="form-control" placeholder="Telefono fijo de la referencia">
                        <span v-if="errorReferencia.telefono_extra" :class="['text-warning']">{{errorReferencia.telefono_extra[0]}}</span>
                    </div>
                </div>

                <div class="form-group" :class="[errorReferencia.direccion ? 'has-warning' : '']">
                    <label class="col-md-3 control-label" for="text-input">Direccion</label>
                    <div class="col-md-9">
                        <input type="text" id="direccion" v-model.trim="referencia.direccion" class="form-control" placeholder="Direccion de la referencia">
                        <span v-if="errorReferencia.direccion" :class="['text-warning']">{{errorReferencia.direccion[0]}}</span>
                    </div>
                </div>

                <div class="form-group" :class="[errorReferencia.email ? 'has-warning' : '']">
                    <label class="col-md-3 control-label" for="text-input">Email</label>
                    <div class="col-md-9">
                        <input type="text" id="email" v-model.trim="referencia.email" class="form-control" placeholder="Email de la referencia">
                        <span v-if="errorReferencia.email" :class="['text-warning']">{{errorReferencia.email[0]}}</span>
                    </div>
                </div>

            </form>
            <span slot="footer">
                <btn type="button" class="btn btn-danger" @click="cerrarModal()">Cerrar</btn>&nbsp;
                <btn type="button" class="btn btn-info" @click="guardarReferencia()" v-text="tipoAccion==1? 'Crear' : 'Actualizar'"></btn>
            </span>
        </modal>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
    name: 'Referencia',
    data: () => {
        return {
            errorSucursal : [],
            tipoAccion : 0,
            modalReferencia : {
                'open' : false,
                'titulo' : '',
                'contenido' : ''
            },
            errorReferencia : [],
        }
    },
    computed: {
        ...mapGetters({'referencias': 'referencia/referencias', 'loading': 'loading'}),
        referencia() {
            return  this.$store.getters['referencia/referencia_id'] && this.$store.getters['referencia/loading'] == false? $.grep(this.$store.getters['referencia/referencias'], (el => {return el.id == this.$store.getters['referencia/referencia_id']}))[0] : {}
        },
    },
    components: {
        TableComponent: () => import('@@/components/table/TableComponent'),
        TableColumn: () => import('@@/components/table/TableColumn'),
        Contacto: () => import('@/views/Contacto.vue')
    },
    methods: {
        getReferencias(deudor_id) {
            this.$store.dispatch('index', {endpoint: 'referencia', params: {deudor_id: deudor_id}})
            .then((response) => {
                if (response.datos.length > 0){
                    this.$store.dispatch('referencia/refresh_referencias', response.datos)
                } else {
                    this.$notify({
                        title: 'Advertencia!',
                        type: 'danger',
                        content: 'No se encontró referencias para este deudor',
                    })
                }
            })
            .catch(() => {
                this.$notify({
                    title: 'Advertencia!',
                    type: 'danger',
                    content: 'Se ha presentado un error realizando su consulta',
                })
            })
        },
        clickEvent(data, slug) {
            this.$store.commit('referencia/SET_REFERENCIA_ID', data.id);
            switch(slug) {
                case 'editar':
                    this.editarReferencia(data);
                    break
                case 'eliminar':
                    this.eliminarReferencia(data);
                    //this.$router.push({name: 'ver-detalle-obligacion', params: { obligacion_id: data.id }})
                    break
            }
        },
        editarReferencia(datos){
           this.abrirModalReferencia('actualizar', datos);
        },
        abrirModalReferencia(accion, data = []){
            this.errorCliente = [];
            switch(accion){
                case 'registrar':
                    this.modalReferencia.open = true;
                    this.modalReferencia.titulo = 'Crear referencia al deudor';
                    this.referencia.id = null;
                    this.referencia.deudor_id =  this.$route.params.deudor_id;
                    this.tipoAccion = 1;
                break;
                case 'actualizar':
                    //this.referencia = this.referencias.find(referencia => referencia.id == data.id)
                    this.modalReferencia.open = true;
                    this.modalReferencia.titulo='Actualizar referencia del deudor';
                    this.tipoAccion=2;
                break;
            }
        },
        eliminarReferencia(referencia) {
            this.$store.commit('referencia/SET_REFERENCIA_ID', referencia.id);
            this.$confirm({
                html: true,
                title: 'Eliminar refenrecia',
                content: 'Esta seguro que desea eliminar esta referencia del deudor?',
                okText : 'Aceptar',
                okType: 'info',
                cancelText: 'Cancelar',
                cancelType: 'danger'
            })
            .then((value) => {
                this.$store.dispatch('referencia/eliminarReferencia', referencia.id)
                .then(response => {
                    this.$notify({
                        title: 'Operación finalizada',
                        content: 'Esta referencia se elimino exitosamente, si desea recuperarla comuniquese con el administrador.'
                    });
                     this.$router.go(0);
                }).catch(error => {
                    console.log(error);
                }).then(() => {

                })
            }).catch(()=>{

            })
        },
        guardarReferencia() {
            this.$store.dispatch('referencia/guardarReferencia', this.referencia)
            .then(() => {
                this.$notify({
                    title: 'Referencia',
                    type: 'success',
                    content: 'Se guardó la referencia satisfactoriamente',
                })
                this.cerrarModal();
                if (this.tipoAccion == 1) {
                    this.$router.go(0);
                }
                //this.$router.go(-1);
            })
            .catch((error) => {
                this.errorReferencia = error.data.errors;
            })
        },
        cerrarModal(){
            //this.$store.commit('referencia/SET_LOADING', true);
            this.modalReferencia.open = false;
            this.tituloModal2='';
            this.errorReferencia = [];
            this.$store.commit('referencia/SET_REFERENCIA_ID', null);
            //this.$store.commit('referencia/SET_LOADING', false)
        },
    },
    mounted() {
        this.getReferencias(this.$route.params.deudor_id)
    }
}
</script>
<style>
.fade:not(.show)#modal-referencia {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.50);
}

.modal-header {
    display: block;
}

.modal-title {
    font-weight: bold;
}

</style>